import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { AssetSubStatus, IconWithTooltip } from "../../../helper/fixcode";
import { Template } from "devextreme-react";
import { assetService } from "../../../apis/apiServices/Asset";
import moment from "moment";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Loader } from "../../Shared/PageLoader";

export default function MyTaskComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [AddrequestList, setAddrequestList] = useState([]);
  const refDataGrid = useRef(null);
  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "",
  });

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "My Tasks";
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      await getMyTasksList();
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
    }
  }, []);

  const getMyTasksList = async () => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      let body = {
        requestId: 0,
        statusId: AssetSubStatus.AssetRequestPending,
        userId: user?.userId,
        formId: 0,
      };
      const response = await assetService.myTaskList(body);
      setAddrequestList(response.data);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
      //console.log(JSON.stringify(response.data));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={AddrequestList}
              ref={refDataGrid}
              keyExpr="requestId"
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  // {
                  //     location: "before",
                  //     template: "toolbarAddTemplate",
                  // },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  }
                  //   {
                  //     location: "after",
                  //     widget: "dxButton",
                  //     options: {
                  //       icon: "refresh",
                  //       onClick: async () => {
                  //         await getMovementRequestLst();
                  //       },
                  //     },
                  //   }
                );
              }}
            >
              <Column
                dataField="requestId"
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                width={140}
                cellRender={(cellData) => {
                  const rowData = cellData?.data;
                  const idPrefix = `icon-${rowData?.requestId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={(data) =>
                                  // navigate("/asset-preview", {
                                  //     state: {
                                  //         requestId: rowData?.requestId,
                                  //         sourceUrl: "MyTasks",
                                  //     },
                                  // })

                                  navigate("/" + rowData?.navigateUrl, {
                                    state: {
                                      requestId: rowData?.requestId,
                                      requestMovementId: rowData?.requestId,
                                      requestQuotationId: rowData?.requestId,
                                      quotationTypeId: rowData?.quotationTypeId,
                                      materialMrId: rowData?.requestId,
                                      stateData: rowData,
                                      formId: rowData?.formId,
                                      sourceUrl: "MyTasks",
                                      isReport: false,
                                    },
                                  })
                                }
                              />
                            </span>
                          </>
                        )}
                        {rowData?.stageId === 1 && (
                          <>
                            {rowData?.editNavigateUrl ===
                              "UpdateMaterialMovementOrder" &&
                            (rowData?.requestStatusId ===
                              Number(
                                AssetSubStatus.MaterialMovementOrderPending
                              ) ||
                              rowData?.requestStatusId ===
                                Number(
                                  AssetSubStatus.MaterialMovementOrderInDraftMode
                                ) ||
                              rowData?.requestStatusId ===
                                Number(
                                  AssetSubStatus.MaterialMovementOrderBackToDraft
                                )) ? (
                              <>
                                <button
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  title="Move"
                                  className="btn btn-primary btn-sm-1"
                                  onClick={() =>
                                    navigate("/UpdateMaterialMovementOrder", {
                                      state: {
                                        requestMovementId: rowData?.requestId,
                                        materialMovementOrderIndentNo:
                                          rowData?.requestNo,
                                        formId: rowData?.formId,
                                        departmentId: rowData?.departmentId,
                                        sourceUrl: "MyTasks",
                                      },
                                    })
                                  }
                                >
                                  <Icon
                                    className="iconify-size mr-1"
                                    icon="ooui:table-move-column-before-rtl"
                                    width="14"
                                    height="14"
                                  />
                                  &nbsp;Order
                                </button>
                              </>
                            ) : rowData?.editNavigateUrl ===
                                "addAssetQuotation" &&
                              (rowData?.requestStatusId ===
                                Number(
                                  AssetSubStatus.RequestForAssetPurchaseInDraftMode
                                ) ||
                                rowData?.requestStatusId ===
                                  Number(
                                    AssetSubStatus.RequestForAssetPurchasePending
                                  ) ||
                                rowData?.requestStatusId ===
                                  Number(
                                    AssetSubStatus.RequestForAssetPurchaseBacktoDraft
                                  )) ? (
                              <>
                                <button
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  title="Move"
                                  className="btn btn-primary btn-sm-1"
                                  onClick={() =>
                                    navigate("/addAssetQuotation", {
                                      state: {
                                        requestQuotationId: rowData?.requestId,
                                        quotationTypeId: 1,
                                        quotationIndentNo: rowData?.requestNo,
                                        formId: rowData?.formId,
                                        departmentId: rowData?.departmentId,
                                        sourceUrl: "MyTasks",
                                      },
                                    })
                                  }
                                >
                                  <Icon
                                    className="iconify-size mr-1"
                                    icon="ooui:table-move-column-before-rtl"
                                    width="14"
                                    height="14"
                                  />
                                  &nbsp;Add Vendor
                                </button>
                              </>
                            ) : rowData?.editNavigateUrl === "addAssetHire" &&
                              (rowData?.requestStatusId ===
                                Number(
                                  AssetSubStatus.RequestForAssetServiceOrderPending
                                ) ||
                                rowData?.requestStatusId ===
                                  Number(
                                    AssetSubStatus.RequestForAssetServiceOrderBacktoDraft
                                  ) ||
                                rowData?.requestStatusId ===
                                  Number(
                                    AssetSubStatus.RequestForAssetServiceOrderInDraftMode
                                  )) ? (
                              <>
                                <button
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  title="Move"
                                  className="btn btn-primary btn-sm-1"
                                  onClick={() =>
                                    navigate("/addAssetHire", {
                                      state: {
                                        requestQuotationId: rowData?.requestId,
                                        quotationTypeId: 2,
                                        quotationIndentNo: rowData?.requestNo,
                                        formId: rowData?.formId,
                                        departmentId: rowData?.departmentId,
                                        sourceUrl: "MyTasks",
                                      },
                                    })
                                  }
                                >
                                  <Icon
                                    className="iconify-size mr-1"
                                    icon="ooui:table-move-column-before-rtl"
                                    width="14"
                                    height="14"
                                  />
                                  &nbsp;Add Vendor
                                </button>
                              </>
                            ) : rowData?.editNavigateUrl ===
                                "addAssetMovement" &&
                              (rowData?.requestStatusId ===
                                Number(AssetSubStatus.AssetMovementPending) ||
                                rowData?.requestStatusId ===
                                  Number(
                                    AssetSubStatus.AssetMovementInDraftMode
                                  )) ? (
                              <>
                                <button
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  title="Move"
                                  className="btn btn-primary btn-sm-1"
                                  onClick={() => {
                                    navigate("/addAssetMovement", {
                                      state: {
                                        requestMovementId: rowData?.requestId,
                                        movementIndentNo: rowData?.requestNo,
                                        departmentId: rowData?.departmentId,
                                        formId: rowData?.formId,
                                        projectId: rowData?.projectId,
                                        workFlowId: rowData?.workFlowId,
                                        sourceUrl: "MyTasks",
                                      },
                                    });
                                  }}
                                >
                                  <Icon
                                    className="iconify-size mr-1"
                                    icon="ooui:table-move-column-before-rtl"
                                    width="14"
                                    height="14"
                                  />
                                  &nbsp;Move
                                </button>
                              </>
                            ) : rowData?.editNavigateUrl ===
                                "SaveMaterialMovementRequest" &&
                              props?.featurePermission?.canEdit &&
                              (rowData?.requestStatusId ===
                                Number(
                                  AssetSubStatus.AssetMaterialMovementPending
                                ) ||
                                rowData?.requestStatusId ===
                                  Number(
                                    AssetSubStatus.AssetMaterialMovementInDraftMode
                                  ) ||
                                rowData?.requestStatusId ===
                                  Number(
                                    AssetSubStatus.AssetMaterialMovementBackToDraft
                                  )) ? (
                              <>
                                <span>
                                  <IconWithTooltip
                                    id={`${idPrefix}-edit`}
                                    className="iconify-size mr-1"
                                    title="Edit"
                                    tooltip="Edit"
                                    icon="solar:pen-line-duotone"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      navigate("/SaveMaterialMovementRequest", {
                                        state: {
                                          materialMrId: rowData?.requestId,
                                          materialMovementNo:
                                            rowData?.requestNo,
                                          formId: rowData?.formId,
                                          statusId: rowData?.statusId,
                                          sourceUrl: "MyTasks",
                                        },
                                      });
                                    }}
                                  />
                                </span>
                              </>
                            ) : rowData?.editNavigateUrl ===
                                "AddAssetRequest" &&
                              props?.featurePermission?.canEdit &&
                              (rowData?.requestStatusId ===
                                Number(AssetSubStatus.AssetRequestPending) ||
                                rowData?.requestStatusId ===
                                  Number(
                                    AssetSubStatus.AssetRequestBackToDraft
                                  )) ? (
                              <>
                                <span>
                                  <IconWithTooltip
                                    id={`${idPrefix}-edit`}
                                    className="iconify-size mr-1"
                                    title="Edit"
                                    tooltip="Edit"
                                    icon="solar:pen-line-duotone"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      navigate("/AddAssetRequest", {
                                        state: {
                                          //stateData: cellData.data,
                                          requestNo: rowData?.requestNo,
                                          requestId: rowData?.requestId,
                                          projectId: rowData?.projectId,
                                          statusId: rowData?.statusId,
                                          sourceUrl: "MyTasks",
                                        },
                                      })
                                    }
                                  />
                                </span>
                              </>
                            ) : rowData?.editNavigateUrl ===
                                "UpdateActionOnRequest" &&
                              !rowData?.isDelete ? (
                              <>
                                <button
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  title="Action"
                                  className="btn btn-primary btn-sm-1"
                                  onClick={() => {
                                    navigate("/UpdateActionOnRequest", {
                                      state: {
                                        requestId: rowData?.requestId,
                                        sourceUrl: "MyTasks",
                                        isReport: false,
                                      },
                                    });
                                  }}
                                >
                                  <Icon
                                    className="iconify-size mr-1"
                                    icon="mdi:call-to-action"
                                    width="14"
                                    height="14"
                                  />
                                  &nbsp;Action
                                </button>
                              </>
                            ) : null}
                          </>
                        )}

                        {/* {props?.featurePermission?.canEdit &&
                          rowData?.stageId === 1 &&
                          rowData?.formId === 1124 && (
                            <>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-edit`}
                                  className="iconify-size mr-1"
                                  title="Edit"
                                  tooltip="Edit"
                                  icon="solar:pen-line-duotone"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    navigate("/" + rowData?.editNavigateUrl, {
                                      state: {
                                        requestId: rowData?.requestId,
                                        requestMovementId: rowData?.requestId,
                                        requestQuotationId: rowData?.requestId,
                                        quotationTypeId:
                                          rowData?.quotationTypeId,
                                        materialMrId: rowData?.requestId,
                                        materialMovementNo: rowData?.requestNo,
                                        stateData: rowData,
                                        formId: rowData?.formId,
                                        sourceUrl: "MyTasks",
                                        isReport: false,
                                      },
                                    });
                                  }}
                                />
                              </span>
                            </>
                          )} */}
                        {/* {props?.featurePermission?.canEdit &&
                          (rowData.statusId ===
                            parseInt(AssetSubStatus.AssetRequestPending) ||
                            rowData.statusId ===
                              parseInt(
                                AssetSubStatus.MaterialMovementOrderInDraftMode
                              )) && (
                            <>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-edit`}
                                  className="iconify-size mr-1"
                                  title="Edit"
                                  tooltip="Edit"
                                  icon="solar:pen-line-duotone"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    debugger;
                                    navigate("/UpdateMaterialMovementOrder", {
                                      state: {
                                        //stateData: cellData.data,
                                        requestMovementId: rowData?.requestId,
                                        materialMovementOrderIndentNo:
                                          rowData?.requestNo,
                                        toProjectId: rowData?.projectId,
                                        workflowId: rowData?.workFlowId,
                                        sourceUrl: "MyTasks",
                                      },
                                    });
                                  }}
                                />
                              </span>
                            </>
                          )} */}
                      </div>
                    </>
                  );
                }}
              ></Column>
              <Column
                dataField="formName"
                caption="Request Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="requestNo"
                caption="Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetRequestSubNo"
                caption="Asset Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetDescriptions"
                caption="Asset Descriptions"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              {/* <Column
                                dataField="requestedDate"
                                caption="Request Date"
                                allowSearch={true}
                                allowFiltering={false}
                                allowSorting={true}
                                dataType="date"
                                format="dd-MMM-yyyy"
                            /> */}
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                //alignment={"center"}
                cellRender={(data) => {
                  if (data?.data?.fromName) {
                    return (
                      <>
                        <span>{data?.data?.fromName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.fromDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                // alignment={"center"}
                cellRender={(data) => {
                  if (data?.data?.toName) {
                    return (
                      <>
                        <span>{data?.data?.toName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              {/* <Column
                dataField="requestSubject"
                caption="Subject"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Column
                dataField="projectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
              />
              <Column
                dataField="createdOn"
                caption="Created On"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.createdOn) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.createdOn).format("DD/MM/YYYY") +
                            " " +
                            moment(data?.data?.createdOn).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.createdByName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="updatedByName"
                caption="Last Updated"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.updatedByName) {
                    return (
                      <>
                        <span>{data?.data?.updatedByName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              {/* <Template
                                name="toolbarAddTemplate"
                                render={() => {
                                    return (
                                        <>
                                            <button
                                                style={{ cursor: "pointer" }}
                                                type="button"
                                                title="Add Movement Request"
                                                className="btn btn-primary btn-sm mr-1"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    try {
                                                        navigate("/AddAssetRequest");
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                            >
                                                <span title="Add Movement Request">
                                                    <i className="fas fa-plus"></i>
                                                    &nbsp;&nbsp;Add
                                                </span>
                                            </button>
                                        </>
                                    );
                                }}
                            /> */}
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getMyTasksList();
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={true} fileName="Asset Request" />
            </DataGrid>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
